
import { RouteObject } from 'react-router-dom';
import HomePage from '../pages/home/page';
import ServicesPage from '../pages/services/page';
import PricelistPage from '../pages/pricelist/page';
import AboutPage from '../pages/about/page';
import ContactPage from '../pages/contact/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/services',
    element: <ServicesPage />,
  },
  {
    path: '/pricelist',
    element: <PricelistPage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
